import React from 'react'
import "./course-desc.scss"
import { isMobile } from '../../../../utils'
const CourseDesc = ({markdown}) => {

    const data = markdown?.data
    const formatValue = (value) => {
        if (!value) return ''
        if (Array.isArray(value)) { return value.join('、') }
        return value
    }
    const infos = [
        { label: '课程', value: data?.title?.split('\n').join('、') },
        { label: '课程类型', value: formatValue(data?.new_course_type) },
        { label: '适合阶段', value: formatValue(data?.new_suit_tags) },
        { label: '课程教具', value: formatValue(data?.new_teaching_aid) },
        { label: '编程平台', value: formatValue(data?.new_program_platform)}
    ].filter(item => item.value)
    if (isMobile()) {
        return (
            <div className="course-desc"> {/* 标题 */} <div className="course-desc-header">
                <span className="course-desc-title">课程概述</span>
                <span className="course-desc-line" /> </div>
                <div className="course-desc-content">
                    {infos.map((item) => (
                        <div className="course-desc-item" key={item.label}>
                            <div className="course-desc-label"> {item.label} </div>
                            <div className="course-desc-value"> {item.value} </div>
                            </div> ))}
                        </div>
                    </div>
        )
    } else {
        return null
    }
}

export default CourseDesc